const BrandSelection = ({
    brand,
    defaultChecked,
    onChange,
}: {
    brand: any;
    defaultChecked: boolean;
    onChange: (brandValue: string, currentChecked: boolean) => void;
}) => {
    const handleOnChange = (brandValue: string, currentChecked: boolean) => {
        onChange(brandValue, currentChecked);
    };

    return (
        <label className="item-center flex justify-between">
            <p className={`text-sm ${defaultChecked && 'font-bold'}`}>{brand.label}</p>
            <input
                type="checkbox"
                id={brand.label}
                name="sorting"
                value={brand.value}
                className="mr-10"
                checked={defaultChecked}
                onChange={e => handleOnChange(brand.value, e.target.checked)}
                aria-label="Chọn thương hiệu"
            />
        </label>
    );
};

export default BrandSelection;
